import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useAlert } from "react-alert";
import { Form, Col, Table, Spinner, Modal, Alert } from "react-bootstrap";
import { baseUrl } from "../../../../services/config";
import ViewSalaryDetails from "./ViewSalaryDetails/ViewSalaryDetails";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import MySelect from "./../../CustomChallan/MySelect";
import makeAnimated from "react-select/animated";
import { components } from "react-select";
import { Paper } from "@material-ui/core";
import EditGeneratedSalary from "./EditGeneratedSalary";
import "./table.css";
const FilterSalary = () => {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  const [designations, setdesignations] = useState([]);
  const [month, setmonth] = useState("");
  const [year, setyear] = useState("");
  const [selectedclasses, setselectedclasses] = useState([]);
  const [Allsessions, setAllsessions] = useState([]);
  const [allData, setallData] = useState([]);
  const [loading, setloading] = useState(false);
  const [currentStaff, setcurrentStaff] = useState({});
  const [viewModal, setviewModal] = useState(false);
  let [optionSelected, setoptionSelected] = useState([]);
  const [optionSelectedvalue, setoptionSelectedvalue] = useState([]);
  const [editsalarymodal, setEditSalaryModal] = useState(false);
  const [filterTable, setfilterTable] = useState(false);
  //states
  const [selectedId, setSelectedId] = useState(null);
  const [AllSalaries, setAllSalaries] = useState([]);
  const [salaryExtraData, setSalaryExtraData] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [allcampuses, setallcampuses] = useState(user.campuses || []);

  const [campusID, setcampusID] = useState("");

  const dispatch = useDispatch();
  let campusidget = useSelector((state) => state.campuses.setselectedcampusid);
  const [previousselectedcampus, setpreviousselectedcampus] = useState(
    campusidget,
  );
  const [searchtext, setsearchtext] = useState("");

  const currentyear = new Date().getFullYear();
  const [selecteddate, setselecteddate] = useState("");
  const selectRow = (item, i) => {
    setSelectedId(item.id);
  };
  const [filtersalarydata, setfiltersalarydata] = useState([]);
  const [selectedsalary, setselectedsalary] = useState([]);

  const [addSalaryModal, setAddSalaryModal] = useState(false);
  const [salaryExtraId, setSalaryExtraId] = useState("");
  const [salaryExtraValue, setSalaryExtraValue] = useState("");
  const [addSalaryLoading, setAddSalaryLoading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  useEffect(() => {
    // getAllCampus();
    getAlldesignations();
    getAllSessions();
    getSalaryExtra();
  }, []);

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          if (data) {
            setAllsessions(data.payload);
            // console.log(data)
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSalaryExtra = async () => {
    await fetch(`${baseUrl}/salary-extras`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setSalaryExtraData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getAlldesignations = () => {
    console.log("designationsssssss");
    fetch(`${baseUrl}/designations`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setdesignations(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchFilter = () => {
    // let newYear = year.substr(0, 4);
    setloading(true);
    setfilterTable(false);
    const data = {
      campus_id: campusID,
      salary_month: `${selecteddate}-01`,
      designation_ids: selectedclasses,
      is_bulk: 1,
    };

    console.log(data);
    fetch(`${baseUrl}/get_salaries_filter`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        res.json().then((data) => {
          console.log(data);
          if (data.payload.salaries != "") {
            setfilterTable(true);
          }
          const sortedData = data?.payload?.salaries?.sort(
            (a, b) => a?.employee?.emp_code - b?.employee?.emp_code,
          );
          // console.log(data.payload + "Salaries Data");
          setfiltersalarydata({ ...data.payload });
          setAllSalaries([...sortedData]);
          setloading(false);
        });
      })
      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };

  const animatedComponents = makeAnimated();
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  const SeeDetails = (salary) => {
    setcurrentStaff(salary);
    setviewModal(true);
  };

  const handleChange = (selected) => {
    console.log(selected);
    let valuearray = [];
    selected.map((item, index) => {
      valuearray[index] = item.value;
    });
    setselectedclasses([...valuearray]);
    setoptionSelectedvalue([...valuearray]);
    setoptionSelected([...selected]);
    console.log(optionSelectedvalue);
  };
  const Options = [];
  designations.map((item, index) => {
    Options[index] = { value: item.id, label: item.name };
  });

  const getAllCampus = async () => {
    await fetch(`${baseUrl}/campus`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) =>
        res.json().then((data) => {
          console.log(data);
          setallcampuses(data.payload);
        }),
      )

      .catch((err) => {
        console.log("campus", err);
      });
  };

  const getAllStaff = (e) => {
    let id;
    if (e == undefined) {
      id = campusID;
    } else if (e != 0) {
      id = e;
      setcampusID(id);
    }

    setpreviousselectedcampus(id);
    dispatch({
      type: "SELECTED_CAMPUS_ID",
      payload: {
        setselectedcampusid: id,
      },
    });

    // setloading(true);
    fetch(`${baseUrl}/employees_index/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        // setloading(false);
      })
      .catch((err) => {
        // setloading(false);
        console.log(err);
      });
  };
  const dataSearch = AllSalaries.filter((user) => {
    let text = searchtext.toLowerCase();
    return searchtext
      ? user?.employee?.full_name?.toLowerCase().includes(text)
      : true;
  });

  const addSalaryExtraHandler = async () => {
    if (salaryExtraId == "" || salaryExtraValue == "") {
      setisallfields(true);
      return;
    }
    setisallfields(false);

    const filterData = salaryExtraData.filter((item) => {
      return item.id === salaryExtraId;
    });
    console.log(filterData);
    const data = {
      salary_id: selectedsalary?.id,
      employee_id: selectedsalary?.employee?.id,
      salary_extra_id: salaryExtraId,
      is_deduction: filterData[0]?.is_deduction,
      value: salaryExtraValue,
    };
    setAddSalaryLoading(true);

    await fetch(`${baseUrl}/employee-defined-extras/store-with-salary-extra`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Salary Extra Successfully Added");
            setAddSalaryModal(false);
            setAddSalaryLoading(false);
            setEditSalaryModal(false);
            setSalaryExtraId("");
            setSalaryExtraValue("");
            searchFilter();
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddSalaryModal(false);
            setAddSalaryLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddSalaryModal(false);
            setAddSalaryLoading(false);
          }
        }),
      )
      .catch((err) => {
        setAddSalaryLoading(false);
        setAddSalaryModal(false);
        console.log(err);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row">
          <div className="col-md-4">
            <label>
              Select Campus <span style={{ color: "red" }}> *</span>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="campus_id"
              value={allcampuses.length === 0 ? "" : previousselectedcampus}
              onChange={(e) => getAllStaff(e.target.value)}
              aria-label="Default select example"
            >
              <option selected value="">
                {" "}
                Select Campus
              </option>
              {allcampuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-4">
            <label>
              Month <span style={{ color: "red" }}>*</span>
            </label>
            <input
              style={{ height: 40 }}
              className="form-control"
              onChange={(e) => setselecteddate(e.target.value)}
              type="month"
              value={selecteddate}
            />
          </div>

          <div className="col-md-4">
            <label>
              Select Desigination <span style={{ color: "red" }}>*</span>
            </label>

            <MySelect
              required
              options={Options}
              isMulti
              name="selectedOptions"
              closeMenuOnSelect={true}
              placeholder="Select All"
              hideSelectedOptions={false}
              components={{ Option, MultiValue, animatedComponents }}
              onChange={handleChange}
              value={optionSelected}
            />
          </div>
        </div>

        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-4">
            <label>Search... </label>

            <input
              className="form-control"
              style={{ height: 40 }}
              onChange={(e) => setsearchtext(e.target.value)}
              id="searchInput"
              placeholder="Search ..."
            />
          </div>
          <div className="col-md-4 mt-9">
            <button
              className="btn btn-success button_blue"
              onClick={searchFilter}
              style={{ width: "100%" }}
              // disabled={selecteddate == ''?true : campusID=="" ? true : false}
            >
              Search
            </button>
          </div>
        </div>

        <br />
        <br />
        {filterTable ? (
          <>
            <div className="tablemain">
              <table className="table">
                <thead className="tablehead">
                  <tr className="tableheadtr text-center">
                    <th className="background-color-primary tableHEadNAme tablehedfixed1">
                      SR.NO
                    </th>
                    <th className="background-color-primary tableHEadNAme tablehedfixed2">
                      Employee Name
                    </th>
                    <th className="background-color-primary tableHEadNAme tablehedfixed3">
                      Employee Code
                    </th>
                    <th className="background-color-primary tableHEadNAme">
                      Account No
                    </th>
                    <th className="background-color-primary tableHEadNAme">
                      Basic Pay
                    </th>
                    {salaryExtraData
                      ?.filter((e) => e.is_deduction !== 1)
                      ?.map((item) => {
                        return (
                          <th className="background-color-primary tableHEadNAme">
                            {item.name}
                          </th>
                        );
                      })}
                    <th className="background-color-primary tableHEadNAme">
                      GPF Return
                    </th>
                    <th className="background-color-primary tableHEadNAme">
                      Gross Salary
                    </th>
                    {salaryExtraData
                      ?.filter((e) => e.is_deduction === 1)
                      ?.map((item) => {
                        return (
                          <th className="background-color-primary tableHEadNAme">
                            {item.name}
                          </th>
                        );
                      })}
                    <th className="background-color-primary tableHEadNAme">
                      GP Fund
                    </th>
                    <th className="background-color-primary tableHEadNAme">
                      Welfare Fund
                    </th>
                    <th className="background-color-primary tableHEadNAme">
                      Loan Refund
                    </th>
                    <th className="background-color-primary tableHEadNAme">
                      Net Pay
                    </th>
                    <th className="background-color-primary tableHEadNAme">
                      Days
                    </th>
                    <th className="background-color-primary tableHEadNAme">
                      View
                    </th>
                    <th className="background-color-primary tableHEadNAme">
                      Edit
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {dataSearch?.map((salary, index) => (
                    <tr
                      key={index}
                      className="tbodytr text-cemter"
                      onClick={() => selectRow(salary, index)}
                      style={{
                        backgroundColor:
                          salary.id == selectedId ? "#D3CECE" : "",
                      }}
                    >
                      <td className="tbodytd fixed">{index + 1}</td>
                      <td
                        className="tbodytd fixed2"
                        title={
                          salary.employee.full_name.length > 15
                            ? salary.employee.full_name
                            : null
                        }
                        style={{ textAlign: "start", cursor: "pointer" }}
                      >
                        {salary.employee.full_name.length > 15
                          ? salary.employee.full_name.substring(0, 12) + "..."
                          : salary.employee.full_name}
                      </td>
                      <td className="tbodytd fixed3">
                        {salary.employee.emp_code}
                      </td>
                      <td className="tbodytd">
                        {salary.account_no ? salary.account_no : "-"}
                      </td>
                      <td className="tbodytd">
                        {Intl.NumberFormat("en-Us").format(salary.basic_pay)}
                      </td>

                      {salaryExtraData
                        ?.filter((e) => e.is_deduction !== 1)
                        .map((extra) => {
                          const match = salary?.employee_salary_extras?.find(
                            (e) =>
                              e.employee_defined_extras?.salary_extra_id ==
                              extra.id,
                          );
                          return (
                            <td className="tbodytd" key={extra.id}>
                              {Intl.NumberFormat("en-US").format(
                                match?.value || 0,
                              )}
                            </td>
                          );
                        })}
                      <td className="tbodytd">
                        {Intl.NumberFormat("en-Us").format(salary.gpf_return)}
                      </td>
                      <td
                        className="tbodytd text-color-primary"
                        style={{ backgroundColor: "darkgray" }}
                      >
                        {Intl.NumberFormat("en-Us").format(salary.gross_salary)}
                      </td>
                      {salaryExtraData
                        ?.filter((e) => e.is_deduction === 1)
                        .map((extra) => {
                          const match = salary?.employee_salary_extras?.find(
                            (e) =>
                              e.employee_defined_extras?.salary_extra_id ==
                              extra.id,
                          );
                          return (
                            <td className="tbodytd" key={extra.id}>
                              {Intl.NumberFormat("en-US").format(
                                match?.value || 0,
                              )}
                            </td>
                          );
                        })}
                      <td className="tbodytd">
                        {Intl.NumberFormat("en-Us").format(salary.gp_fund)}
                      </td>
                      <td className="tbodytd">
                        {Intl.NumberFormat("en-Us").format(salary.welfare_fund)}
                      </td>
                      <td className="tbodytd">
                        {Intl.NumberFormat("en-Us").format(salary.loan_refund)}
                      </td>
                      <td className="tbodytd">
                        {Intl.NumberFormat("en-Us").format(salary.net_pay)}
                      </td>
                      <td className="tbodytd">{salary?.days}</td>
                      <td className="tbodytd">
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => SeeDetails(salary)}
                          className="svg-icon svg-icon-md svg-icon-primary-custom"
                        >
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Unlock.svg",
                            )}
                          />
                        </span>
                      </td>
                      <td className="tbodytd">
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setEditSalaryModal(true);
                            setselectedsalary(salary);
                          }}
                          className="svg-icon svg-icon-md svg-icon-primary-custom"
                        >
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Edit.svg",
                            )}
                          />
                        </span>
                      </td>
                    </tr>
                  ))}
                  <tr className="tbodytr">
                    <th className="tbodytd fixed"></th>
                    <th className="tbodytd fixed2"></th>
                    <th className="tbodytd fixed3"></th>
                    <th className="tbodytd"></th>
                    <th
                      colSpan={salaryExtraData?.length + 1}
                      className="tbodytd"
                    ></th>
                    <th
                      className="tbodytd text-center text-color-primary"
                      colSpan={2}
                    >
                      Total Basic Salary :-
                    </th>
                    <th className="tbodytd text-center">
                      {Intl.NumberFormat("en-Us").format(
                        AllSalaries?.reduce(
                          (a, c) => a + parseInt(c.basic_pay),
                          0,
                        ),
                      )}
                    </th>
                    <th
                      className="tbodytd text-center text-color-primary"
                      colSpan={2}
                    >
                      Total Gross Salary :-
                    </th>
                    <th className="tbodytd text-center">
                      {" "}
                      {Intl.NumberFormat("en-Us").format(
                        filtersalarydata.total_gross_salary,
                      )}
                    </th>
                    <th
                      className="tbodytd text-center text-color-primary"
                      colSpan={2}
                    >
                      Total Net Salary :-
                    </th>

                    <th className="tbodytd text-center">
                      {" "}
                      {Intl.NumberFormat("en-Us").format(
                        filtersalarydata.total_net_salary,
                      )}
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        ) : null}

        {loading && (
          <div className="row justify-content-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}

        <Modal onHide={() => setviewModal(false)} show={viewModal} size="xl">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              View Salary Details
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <ViewSalaryDetails EmpDetails={currentStaff} />
          </Modal.Body>

          <Modal.Footer>
            <button
              onClick={() => setviewModal(false)}
              className="btn btn-danger btn_width"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal show={editsalarymodal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Edit Salary - {selectedsalary?.employee?.full_name}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <input
                disabled
                className="form-control col-md-4 m-3"
                defaultValue={`Net Pay: ${Intl.NumberFormat("en-Us").format(
                  selectedsalary.net_pay,
                )}`}
              />
              <input
                disabled
                className="form-control col-md-4 m-3"
                defaultValue={`Gross Salary: ${Intl.NumberFormat(
                  "en-Us",
                ).format(selectedsalary.gross_salary)}`}
              />
              {/* <button
                onClick={() => setAddSalaryModal(true)}
                className="btn btn-primary m-3 w-150px"
              >
                Add Salary Extra
              </button> */}
            </div>
            {/* <h3>Net Pay :{selectedsalary.net_pay} Gross Salary :{selectedsalary.gross_salary}</h3> */}
            <EditGeneratedSalary
              staffDetails={selectedsalary}
              salaryExtraData={salaryExtraData}
              show={() => setEditSalaryModal()}
              reload={() => searchFilter()}
            />
          </Modal.Body>
        </Modal>

        {/* <Modal show={addSalaryModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add Salary Extra - {selectedsalary?.employee?.full_name}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Salary Extra <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <select
                  className="form-control form-select h-40px"
                  name="salary_extra_id"
                  onChange={(e) => {
                    setSalaryExtraId(e.target.value);
                  }}
                >
                  <option value="">Select Salary Extra</option>
                  {salaryExtraData?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Amount <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  type="number"
                  className="form-control"
                  value={salaryExtraValue}
                  onChange={(e) => {
                    setSalaryExtraValue(e.target.value);
                  }}
                  placeholder="Enter Amount"
                />
              </div>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addSalaryLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addSalaryExtraHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddSalaryModal(false);
                setisallfields(false);
                setSalaryExtraId("");
                setSalaryExtraValue("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal> */}
      </Paper>
    </div>
  );
};

export default FilterSalary;
